import React from "react";

const About = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>
        This is a more complex React setup including routing, context API, and
        API calls.
      </p>
    </div>
  );
};

export default About;
